import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_3 = { ref: "cpToken" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Re-generate API key ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "height-100"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Retrieving Key .... "))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.apiKey), 1))
      ], 512),
      _hoisted_6,
      _createVNode(_component_el_button, {
        type: _ctx.copied ? 'success' : 'primary',
        disabled: _ctx.dataLoading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy(_ctx.apiKey)))
      }, {
        default: _withCtx(() => [
          (!_ctx.copied)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Copy"))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "Copied!"))
        ]),
        _: 1
      }, 8, ["type", "disabled"]),
      _hoisted_9,
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _ctx.dataLoading,
        onClick: _ctx.regenerate
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}